import { render, staticRenderFns } from "./lxjl.vue?vue&type=template&id=5fe570ee&"
import script from "./lxjl.vue?vue&type=script&lang=js&"
export * from "./lxjl.vue?vue&type=script&lang=js&"
import style0 from "./lxjl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports